import { make } from 'vuex-pathify';

const getDefaultState = () => {
  return {
    category: 'airportparking',
    dateA: '2019-12-12',
    dateB: '2019-12-15',
    dateC: '',
    dateD: '',
    timeA: '11:30',
    timeB: '12:45',
    timeC: '',
    timeD: '',
    agent: 'ONLINE',
    promo: '',
    passengers: 0,
    serviceCode: '',
    adults: "1",
    children: "0",
    infants: "0",
    website_id: 0,
    parking_days: 0,
    country: 0,
    resortA: 0,
    transfer_type: '',
    include_parking: 0,
    return: 0,
    manual_discount: 0,
    room1: '1',
    room2: '',
    rhp: 0,
    params: [],
    airportA: 1,
    _timestamp: new Date,
    quoteID: null,
    referrer: '',
    hotelToParking: false,
  }
}

// initial state
const state = getDefaultState();

const mutations = {
  ...make.mutations(state),
  clearQuote() {
    this.state.quote = getDefaultState();
  }
};

const actions = {
  ...make.actions(state),
  async clearQuote(context) {
    await context.commit('clearQuote')
  }
};

const getters = make.getters(state);

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
};